import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Intro } from './Intro/Intro';
import { OurProcesses } from './OurProcesses/OurProcesses';
import TabNavIconCloud from 'src/svgs/process.button.circle.cloud.svg';
import TabNavIcon from 'src/svgs/process.button.circle.svg';
import ProcessesBackgroundCloud from 'src/svgs/process.diagram.cloud.svg';
import ProcessesBackground from 'src/svgs/process.diagram.svg';
import './OurProcessesSection.scss';

const processStyles = [
  {
    buttonClass: 'btn-gradient-cloud',
    tabClass: 'btn-link-cloud',
    dividerClass: 'divider-cloud',
    icon: TabNavIconCloud,
    background: ProcessesBackgroundCloud,
  },
  {
    buttonClass: 'btn-gradient-secondary',
    tabClass: 'btn-link-secondary',
    dividerClass: 'divider-primary',
    icon: TabNavIcon,
    background: ProcessesBackground,
  },
];

const getProccessStyle = (processIndex) => {
  const defaultStyle = processStyles[1];
  if (!processStyles[processIndex]) return defaultStyle;
  return processStyles[processIndex];
};

export const OurProcessesSection = ({ title, ourProcesses }) => {
  const [activeProcessIndex, setActiveProcessIndex] = useState(0);

  if (ourProcesses.length === 0) return null;

  const processes = ourProcesses.map((e, i) => ({ ...e, styles: getProccessStyle(i), index: i }));

  const activeProcess = processes.find((e) => e.index === activeProcessIndex);

  return (
    <section className="bg-shapes-clouds-dark-v2 pb-xl-0 pt-lg-10 py-6">
      <Container id="folyamatunk">
        <Intro title={title} activeProcess={activeProcess} onActiveProcessIndexChange={setActiveProcessIndex} processes={processes} />

        <OurProcesses activeProcess={activeProcess} />
      </Container>
    </section>
  );
};
